module.exports = __webpack_public_path__ + "static/img/gt.4741af7.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/gt.gif
// module id = XDFi
// module chunks = 104